import { Flex, Stack, type StackProps } from '@chakra-ui/react';
import { AdvertisementPosition } from '../../features/advertisement/types.ts';
import { AdBanner } from '../../features/advertisement/AdBanner.tsx';
import { AdminRouteItems, ClientRouteItems } from '../../routes/AppRouter.tsx';
import { SidebarNavItems } from './sidebarNavItems.tsx';

interface SidebarProps extends StackProps {
  showAdminNav: boolean;
}

export const Sidebar = (props: SidebarProps) => {
  const { ...rest } = props;

  return (
    <Stack p={'4'} bg='bg.panel' {...rest}>
      <Stack gap='8' width={'224px'}>
        <SidebarNavItems items={ClientRouteItems} />
        {props.showAdminNav && <SidebarNavItems items={AdminRouteItems} />}
      </Stack>
      <Flex direction={'column'}>
        <AdBanner numberOfAdsToDisplay={1} position={AdvertisementPosition.NavbarOne} />
        <AdBanner numberOfAdsToDisplay={1} position={AdvertisementPosition.NavbarTwo} />
        <AdBanner numberOfAdsToDisplay={1} position={AdvertisementPosition.NavbarThree} />
      </Flex>
    </Stack>
  );
};
